import { GroupCloth, Shoes, Electronics, FemaleCloth, MaleCloth, Books, Jewelry } from '../Assets/Images/Image';
const data = [
    {
        img: GroupCloth,
        name: "Clothes"
    },
    {
        img: Shoes,
        name: "Shoes"
    },
    {
        img: FemaleCloth,
        name: "Clothes"
    },
    {
        img: Electronics,
        name: "Electronics"
    },
    {
        img: MaleCloth,
        name: "Clothes"
    },
    {
        img: Books,
        name: "Books"
    },
    {
        img: Jewelry,
        name: "Jewelry"
    },
]
export default data